module.exports = __webpack_public_path__ + "static/media/animated-2-Ca.a1e1092a.gif";